import service from './index';

export default {
  async getAll (params) {
    const response = await service.get('/media-center', {
      params,
      hideErrorMessage: true,
      hideSpinner: true,
    });
    return response;
  },
  async getAllByName (params) {
    const response = await service.get('/media-center/by-image-name', {
      hideSpinner: true,
      params,
    });
    return response;
  },
  async prepareToUpload (fileName) {
    const response = await service.get(`/media-center/prepare-upload?fileName=${fileName}`, {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
  async uploadToImage (params) {
    const response = await service.post('/media-center/upload-image', params, {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
  async removeImage (fileId) {
    const response = await service.delete(`/media-center/${fileId}`, {
      hideSpinner: true,
    });
    return response;
  },
  async getFileInfo (url) {
    const response = await service.get(`${url}?x-oss-process=image/info`, {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
  async prepareToUploadS3 (fileName) {
    const response = await service.get(`/media-center/cdn-prepare-upload?fileNames=${fileName}`, {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
};
